<template>
    <sub-page class="m-editLedger">
        <el-form :model="ruleForm" :rules="rules" class="form-ledger" ref="ruleForm" label-width="120px" size="small">
            <!-- 培训类别 -->
            <el-form-item :label="$t('train.type')" prop="type">
                <el-select v-model="ruleForm.type" collapse-tags :placeholder="$t('tip.trainingType')">
                    <el-option :label="item.value" :value="item.id" v-for="item in trainTypeMenu" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!-- 培训名称 -->
            <el-form-item :label="$t('train.name')" prop="name">
                <el-input v-model="ruleForm.name" :placeholder="$t('tip.name')" clearable></el-input>
            </el-form-item>
            <!-- 项目类别 -->
            <el-form-item label="项目类别" prop="projectType">
                <el-select v-model="ruleForm.projectType" collapse-tags placeholder="请选择项目类别">
                    <el-option :label="item.value" :value="item.id" v-for="item in projectTypeMenu" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!-- 培训人员 -->
            <el-form-item label="培训人员" prop="participants" class="item-participants">
                <div class="trainee">
                    <el-tag size="mini" @close="deleteUser(index)" v-for="(item, index) in ruleForm.participants" :key="item.userId" closable>{{item.userName}}</el-tag>
                </div>
                <el-button @click="addUser" type="primary" circle size="small" title="添加培训人员"><i class="nucfont inuc-add"></i></el-button>
            </el-form-item>

            <div class="item-col-2">
                <!-- 培训人数 -->
                <el-form-item label="培训人数" prop="numOfTrainees">
                    <el-input-number v-model="ruleForm.numOfTrainees" controls-position="right" :min="0" :max="10000"></el-input-number>
                </el-form-item>
                <!-- 培训地点 -->
                <el-form-item :label="$t('train.site')" prop="place">
                    <el-input v-model="ruleForm.place" clearable></el-input>
                </el-form-item>
                <!-- 学时 -->
                <el-form-item label="学时" prop="hours">
                    <el-input-number v-model="ruleForm.hours" controls-position="right" :min="0" :max="400"></el-input-number>
                </el-form-item>
                <!-- 考核方式 -->
                <el-form-item label="考核方式" prop="form">
                    <el-select v-model="ruleForm.form" collapse-tags placeholder="请选择考核方式">
                        <el-option :label="item.value" :value="item.id" v-for="item in examFormMenu" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 学分 -->
                <el-form-item label="学分" prop="score">
                    <el-input-number v-model="ruleForm.score" controls-position="right" :min="0" :max="400"></el-input-number>
                </el-form-item>
                <!-- 实施时间 -->
                <el-form-item label="实施时间" prop="startTime">
                    <el-date-picker
                        v-model="ruleForm.startTime"
                        type="date"
                        placeholder="请选择实施时间"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <!-- 内训师级别 -->
                <el-form-item label="内训师级别" prop="trainerLevel">
                    <el-select v-model="ruleForm.trainerLevel" collapse-tags placeholder="请选择内训师级别">
                        <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 结束时间 -->
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker
                        v-model="ruleForm.endTime"
                        type="date"
                        placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <!-- 年度 -->
                <el-form-item label="年度" prop="year">
                    <el-select v-model="ruleForm.year" collapse-tags placeholder="请选择年度">
                        <el-option :label="item.value" :value="item.id" v-for="item in yearMenu" :key="item.id"></el-option>
                    </el-select>
<!--                    <el-date-picker-->
<!--                        v-model="ruleForm.year"-->
<!--                        type="year"-->
<!--                        placeholder="请选择年度">-->
<!--                    </el-date-picker>-->
                </el-form-item>
                <!-- 考核日期 -->
                <el-form-item label="考核日期" prop="assessmentTime">
                    <el-date-picker
                        v-model="ruleForm.assessmentTime"
                        type="date"
                        placeholder="请选择考核日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </div>

            <!-- 培训内容 -->
            <el-form-item label="培训内容" prop="content">
                <el-input type="textarea"
                          v-model="ruleForm.content"
                          :autosize="{ minRows: 5, maxRows: 10}"></el-input>
            </el-form-item>

            <div class="item-col-2">
                <!-- 授课人员 -->
                <el-form-item label="授课人员" prop="trainer">
                    <el-input v-model="ruleForm.trainer" placeholder="请输入授课人员" clearable></el-input>
                </el-form-item>
                <!-- 培训部门 -->
                <select-multi-orgs
                    label="培训部门"
                    prop="institutions"
                    :single="true"
                    :defaultCheckedKeys="checkedOrgs"
                    @orgsChange="orgsChange">
                </select-multi-orgs>
            </div>

            <!-- 附件 -->
            <el-form-item class="item-files">
                <template v-slot:label>
                    <div>附件 (<span style="color:#22B9FF"> {{ruleForm.attachments.length}} </span>)</div>
                </template>

                <div class="file-area">
<!--                    <ledger-file :initFiles="initFiles" @file-change="fileChange"></ledger-file>-->
                    <filelist-uploader
                        :initFiles="initFiles"
                        :limit="200"
                        @file-change="fileChange"></filelist-uploader>
                </div>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea"
                          v-model="ruleForm.remark"
                          :autosize="{ minRows: 3, maxRows: 5}"></el-input>
            </el-form-item>

            <div class="btn-group">
                <el-button type="primary" @click="toSave" :loading="submitLoading">保存</el-button>
            </div>
        </el-form>

        <!-- trainee dialog -->
        <trainee-dialog :traineeDialog.sync="traineeDialog"
                        :selectedTable="ruleForm.participants"
                        :filterType="2"
                        @dialog-save="traineeDialogSave"
        ></trainee-dialog>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import {mapGetters} from 'vuex'
    import {Ticket} from '@/utils';
    import SubPage from '@/components/Subpage'
    import selectMultiple from '@/components/Selectmultiple'
    import selectMultiOrgs from '@/components/SelectMultiOrgs';
    import AdvancedFilter from '@/components/AdvancedFilter';
    import traineeDialog from '@/components/Dialog/TraineeDialog'
    import ledgerFile from './Components/File'
    import dayjs from 'dayjs'
    import FilelistUploader from "@components/UI/FilelistUploader";

    export default {
        props: ['ledgerId'],
        components: {
            FilelistUploader,
            SubPage,
            selectMultiple,
            selectMultiOrgs,
            AdvancedFilter,
            traineeDialog,
            ledgerFile
        },
        data() {
            return {
                ruleForm: {
                    type: '',
                    name: '',
                    projectType: '',
                    participants: [],
                    numOfTrainees: 0,
                    place: '',
                    hours: 0,
                    form: '',
                    score: 0,
                    startTime: '',
                    trainerLevel: '',
                    endTime: '',
                    year: '',
                    assessmentTime: '',
                    content: '',
                    trainer: '',
                    institutions: '',
                    attachments: [],
                    remark: ''
                },

                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {min: 2, max: 100, message: this.$t('rule.lengthBetween', ['2', '100']), trigger: 'blur'}
                    ],
                    type: [{required: true, message: this.$t('tip.examType'), trigger: 'change'}],
                    projectType: [{required: true, message: '请选择项目类别', trigger: 'change'}],
                    participants: [{required: true, message: '请选择培训人员', trigger: 'change'}],
                    numOfTrainees: [{required: true, min: 1, type: 'integer', message: '请输入培训人数', trigger: 'blur'}],
                    place: [
                        {required: true, message: '请输入培训地点', trigger: 'blur'},
                        {min: 2, max: 500, message: this.$t('rule.lengthBetween', ['2', '500']), trigger: 'blur'}
                    ],
                    hours: [{required: true, min: 1, type: 'integer', message: '请输入学时', trigger: 'blur'}],
                    form: [{required: true, message: '请选择考核方式', trigger: 'change'}],
                    score: [{required: true, min: 1, type: 'integer', message: '请输入学分', trigger: 'blur'}],
                    startTime: [{required: true, message: '请选择实施时间', trigger: 'blur'}],
                    trainerLevel: [{required: true, message: '请选择内训师级别', trigger: 'change'}],
                    endTime: [{required: true, message: '请选择结束时间', trigger: 'blur'}],
                    year: [{required: true, message: '请选择年度', trigger: 'change'}],
                    assessmentTime: [{required: true, message: '请选择考核日期', trigger: 'blur'}],
                    trainer: [
                        {required: true, message: '请输入授课人员', trigger: 'blur'},
                        {min: 2, max: 100, message: this.$t('rule.lengthBetween', ['2', '100']), trigger: 'blur'}
                    ],
                    institutions: [{required: true, message: '请选择培训部门', trigger: 'change'}],
                    content: [{max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}],
                    remark: [{max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}],
                },

                traineeDialog: false,
                submitLoading: false,
                checkedOrgs: [],
                initFiles: []
            }
        },
        created() {
            this.$store.dispatch('getTrainTypeMenu');
            // 考核方式默认取第一项
            this.$store.dispatch('getExamFormMenu').then(res => {
                if (!this.ledgerId && res.length) {
                    this.ruleForm.form = res[0]['id']
                }
            })
            this.$store.dispatch('getForLevelMenu');
            this.$store.dispatch('getProjectTypeMenu');

            // 编辑
            if (this.ledgerId) {
                this.initData()
            } else {
                this.setDefaultData()
            }
        },
        computed: {
            ...mapGetters([
                'trainTypeMenu',
                'examFormMenu',
                'forLevelMenu',
                'projectTypeMenu'
            ]),
            creator() {
                return Ticket.get()
            },
            yearMenu() {
                let myDate = new Date();
                let nowYear = myDate.getFullYear(); //起始年份
                let oldYear = nowYear - 9; //结束年份
                let years = []
                for (var i=oldYear;i<=nowYear;i++) {
                    years.push({id:i,value:i});
                }
                return years.reverse()
            },
        },
        methods: {
            initData() {
                api.getStandingBook(this.ledgerId).then(res => {
                    let data = res.package;

                    for (let item in data) {
                        if (this.ruleForm.hasOwnProperty(item)) {
                            this.ruleForm[item] = data[item];
                        }
                    }

                    this.checkedOrgs = data.institutions.map(item => item.orgId)
                    this.initFiles = data.attachments;

                    // 威视的台账 projectType、place为非必填
                    if (data.origin === 2) {
                        this.rules.projectType = []
                        this.rules.place = []
                        this.rules.hours = []
                        this.rules.score = []
                    }
                })
            },
            setDefaultData() {
                this.ruleForm.year = dayjs().year()
                let today = dayjs().format('YYYY-MM-DD')
                let sevenDaysLater = dayjs().add(7, 'day').format('YYYY-MM-DD')
                this.ruleForm.startTime = today
                this.ruleForm.assessmentTime = today
                this.ruleForm.endTime = sevenDaysLater
            },

            addUser() {
                this.traineeDialog = true;
            },
            deleteUser(n) {
                this.ruleForm.participants.splice(n ,1)
            },
            traineeDialogSave(data) {
                this.ruleForm.participants = [];

                data.forEach(item => {
                    this.ruleForm.participants.push({
                        userId: item.id,
                        userName: item.name
                    })
                })

                this.traineeDialog = false;
                this.$refs["ruleForm"].validateField('participants');
            },

            fileChange(fileList) {
                this.ruleForm.attachments = fileList.map(item => {
                    return {
                        id: item.response && item.response.id
                    }
                })
            },

            toSave() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (!valid) return;

                    let result = {...this.ruleForm};

                    this.submitLoading = true;

                    if (this.ledgerId) {
                        result.id = this.ledgerId;
                        api.editStandingBook(result).then(res => {
                            this.$notify({
                                title: res.message,
                                message: '台账修改成功！',
                                type: 'success',
                                duration: 2000
                            });

                            this.submitLoading = false;
                            this.$emit('onClose');
                            this.$router.replace({name: 'ledgerIndex'})
                        }).catch(e => this.submitLoading = false);
                    } else {
                        api.postStandingBook(result).then(res => {
                            this.$notify({
                                title: res.message,
                                message: '台账添加成功！',
                                type: 'success',
                                duration: 2000
                            });

                            this.submitLoading = false;
                            this.$emit('onClose');
                            this.$router.replace({name: 'ledgerIndex'})
                        }).catch(e => this.submitLoading = false);
                    }

                })
            },

            orgsChange(data) {
                this.ruleForm.institutions = data.map(id => {
                    return  {orgID: id}
                });
            },
        },
        watch: {
            'ruleForm.participants'(v) {
                let length = v.length
                this.ruleForm.numOfTrainees = length
            }
        },
    }
</script>

<style scoped lang="scss">
    .form-ledger {
        width: 1000px;
        @media screen and (max-width: 1366px) {
            width: 690px;
        }

        .el-form-item {
            //margin-bottom: 16px;
        }

        .item-col-2 {
            display: flex;
            flex-wrap: wrap;
            .el-form-item {
                flex-basis: 50%;
            }
        }

        .creator .el-form-item {
            color: #999;
        }

        .item-participants {
            .trainee {
                min-height: 120px;
                max-height: 240px;
                padding: 5px;
                line-height: 30px;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                overflow-y: auto;
                .el-tag {
                    margin-left: 10px;
                }
            }
            button {
                position: absolute;
                top: 50%;
                margin-top: -16px;
                right: -50px;
            }
        }

        .item-files {
            .file-area {
                min-height: 172px;
                max-height: 480px;
                padding: 10px 10px 0 10px;
                border: 1px solid #cad8e1;
                overflow-y: auto;
            }
        }
    }

    .btn-group {
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: center;
    }

    @media screen and (max-width: 1440px) {
        .form-ledger {
            //width: 900px;
        }
    }
</style>
